import { formatCurrency, type CurrencyCode } from './currency'

/** Деньги: всегда через Intl (пробелы в тысячах, запятая). */
export const money = (v: number, c: CurrencyCode = 'RUB') => formatCurrency(v, c)

/** Вес без единицы: 3 знака, запятая (для пар «остаток / начальный»). */
export const kg = (v: number) =>
  new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3
  }).format(v)

/** Количество: кг — 3 знака с единицей, штучное — как есть. */
export function qty(v: number, unit?: string): string {
  if (unit === 'кг') return `${kg(v)} кг`
  return String(v)
}
